import {Action} from "@ngrx/store";
import {HostingRedirectData} from '../../websites/website/hosting/redirects/hostingRedirectData';

export const LOAD_REDIRECTS: string = '[redirect] Load Redirects';
export const LOAD_REDIRECTS_SUCCESS: string = '[redirect] Load Redirects Success';
export const LOAD_REDIRECTS_FAIL: string = '[redirect] Load Redirects Fail';

export class LoadRedirects implements Action {
  readonly type: string = LOAD_REDIRECTS;
  constructor(public payload: number) {}
}

export class LoadRedirectsSuccess implements Action {

  readonly type: string = LOAD_REDIRECTS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: {[websiteId: number]: HostingRedirectData},
  }) {}

}

export class LoadRedirectsFail implements Action {

  readonly type: string = LOAD_REDIRECTS_FAIL;
  constructor(public payload: string) {}

}


export type RedirectAction = LoadRedirects | LoadRedirectsSuccess | LoadRedirectsFail;
